import { NAMESPACE } from './base';

export const actions = {
  updateImagePreviewComponent: `${NAMESPACE}_UPDATE_IMAGE_PREVIEW_COMPONENT`,
  resetImagePreview: `${NAMESPACE}_RESET_IMAGE_PREVIEW`,
  requestValidateSkuImageUrl: `${NAMESPACE}_REQUEST_VALIDATE_URL_SKU_IMAGE`
};

export const actionCreators = {
  updateImagePreviewComponent: (payload) => ({
    type: actions.updateImagePreviewComponent,
    payload
  }),
  requestValidateSkuImageUrl: ({ imageUrl }) => ({
    type: actions.requestValidateSkuImageUrl,
    payload: { imageUrl }
  }),
  resetImagePreview: () => ({ type: actions.resetImagePreview })
};

export default {
  actions,
  actionCreators
};
